import * as React from 'react';
import { connect } from 'react-redux';
import * as ReactDOM from 'react-dom';
import { Link, withRouter } from 'react-router-dom';
import { bindActionCreators } from "redux";
import InlineTextDisplay from '../Controls/InlineTextDisplay';
import * as CreDtos from "../../CRE.dtos";
import { AustraliaMap } from '../../shared';
import { PublishedItem } from '../../components/Publications/PublishedItem';

class ResearchItem extends React.Component<any, any> {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentDidUpdate(prevprops) {
        if (this.props.id != prevprops.id) {
            window.scrollTo(0, 0);
        }
    }

    render() {
        let item: CreDtos.Research = { ...this.props.research };

        let mapActiveCss = "map-active-yellow";
        let recruitingCss = "base1-bg";
        let focusBadgeCss = "focus-badge focus-badge-yellow";

        let researchPeople;
        if (item.researchPeople && item.researchPeople.filter(f => f.enabled && f.people && f.people.peopleType == 2).length > 0) {
            let researchers = item.researchPeople.filter(f => f.enabled).map((content, index) => {
                let link = content.peopleCategoryId == 0 ? !content.link || content.link === "" ? <span>{content.name}</span> : <a href={content.link} target='_blank'>{content.name}</a> :
                    !content.link || content.link === "" ? <a href={`/AboutUs#${content.name}`}>{content.name}</a> : <a href={content.link} target='_blank'>{content.name}</a>;
                return <div key={"content" + index}>{link}</div>
            });
            researchPeople = <div>
                <h6 className="mt-4">RESEARCHERS</h6>
                {researchers}
            </div>
        }

        let externalResearch;
        //if (item.researchPeople && item.researchPeople.filter(f => f.enabled && f.people && f.people.peopleType == 0).length > 0) {
        //    let externalResearchers = item.researchPeople.filter(f => f.enabled && f.people && f.people.peopleType == 0).map((content, index) => {
        //        return <div key={"content" + index}>{content.name}</div>
        //    });
        //    externalResearch = <div>
        //        <h6 className="mt-4">EXTERNAL RESEARCHERS</h6>
        //        {externalResearchers }
        //    </div>
        //}

        let recruiting;
        if (item.recruiting && item.researchContact && item.researchContact.length) {

            let primaryContact = item.researchContact[0].email;
            recruiting = item.recruiting ? (<a href={`mailto:${primaryContact}?subject=Now Recruiting query for ${item.title}`} className={`btn btn-block btn-secondary ${recruitingCss} mb-3 `}>
                NOW RECRUITING
            </a>) : undefined;

        }


        let loginButton = item.forumId ? <Link to={{ pathname: "/DiscussionBoard", search: `id=${item.forumId}` }}
            className={`btn btn-block btn-secondary ${recruitingCss} mb-3 `}>LOGIN</Link> : undefined;

        let focus
        if (item.researchFocus) {
            focus = item.researchFocus.map((item, index) => {
                return <div key={"content" + index}>
                    <span>{item.focus.focusName}</span>
                </div>
            });
        }

        let contentDetail;
        contentDetail = (
            <div key={"content"} className="mb-1">
                <InlineTextDisplay source={item.content} />
            </div>
        );

        let image = item.images && item.images.length > 0 ? <img className="mb-4 pb-4" src={"./." + item.images} /> : undefined;
        let contactDetails;
        if (item.researchContact) {
            contactDetails = item.researchContact.filter(f => f.enabled).map((contact, i) => <div key={"contact_" + i} className="mb-2">
                <div dangerouslySetInnerHTML={{ __html: contact.name }}></div>
                <a href={`mailto:${contact.email}?subject=${contact.subject}`} className="muted-link">{contact.email}</a>
            </div>);
        }


        let resources;
        if (item.researchPublication && item.researchPublication.filter(f => f.enabled).length != 0) {
            resources = item.researchPublication.filter(f => f.enabled).map((item, index) => {
                return <PublishedItem key={"researchPublication_" + index} idx={index} {...item.publication}></PublishedItem>;
            });
        } else {
            resources = ([<div>To follow</div>]);
        }

        let australiaMap;
        if (item.researchState) {
            let states = [];
            item.researchState.filter(f => f.enabled).forEach(s => {
                states.push(s.state.stateName);
            });
            australiaMap = (
                <div className="text-center">
                    <AustraliaMap states={states} activeCss={mapActiveCss} disabledCss="map-disabled-light" />
                </div>
            );
        }

        let titleHtml = item.titleLine1;
            if (item.titleLine2 && item.titleLine2.length > 0) {
                titleHtml = titleHtml + '<br />' + item.titleLine2;
            }

        return (<div  id="SectionContainer" ref="research-detail" >
            <section className="content page-content" >
                <div>
                    <div className="container " >
                        <div className="mb-2" >
                            <h1 className="my-5" dangerouslySetInnerHTML={{ __html: titleHtml }}></h1>
                        </div>
                        <div className="row mt-5">
                            <div className="research-content col-12 col-md-9">
                                {image}
                                {contentDetail}
                                <div className="mb-4">
                                    <h5>Publications / Resources</h5>
                                    <div className="publication-table">
                                        {resources}
                                    </div>
                                </div>
                            </div>
                            <div className="research-sidebar col-12 col-md-3">
                                {loginButton}
                                {recruiting}
                                {australiaMap}
                                <h6>FOCUS</h6>
                                {focus}
                                {researchPeople}
                                {externalResearch }
                                <h6 className="mt-4">FUNDING BODY</h6>
                                <InlineTextDisplay source={item.fundingBody} />
                                <div className="mb-4">
                                    <h6 className="mt-3">CONTACT</h6>
                                    {contactDetails}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </div>
        );
    }
}

const getResearchProject = (research: CreDtos.Research[], id) => {
    if (research && research.length > 0) {
        let projects = research.filter(r => r.anchor && r.anchor.toLowerCase() == id.toLowerCase());
        if (projects.length > 0) {
            return projects[0];
        }
        projects = research.filter(r => r.title.split(' ').join('').toLowerCase() == id.toLowerCase());
        if (projects.length > 0) {
            return projects[0];
        }
    }
    return {};
}

const mapStateToProps = (state, ownProps) => {
    return {
        research: getResearchProject(state.siteData.siteData.research, ownProps.match.params.id),
        id: ownProps.match.params.id,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {},
        dispatch
    );
};


const ResearchItemContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(
    ResearchItem
));

export default ResearchItemContainer;


// WEBPACK FOOTER //
// ./src/components/Research/ResearchItem.tsx